import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';

// Normalize a single field value so equivalent values written by the importer
// (numbers, trimmed strings, empty/missing) compare as equal.
const normalizeValue = (v) => {
  if (v === null || v === undefined) return '';
  if (typeof v === 'number') return Number.isFinite(v) ? String(v) : '';
  if (typeof v === 'string') return v.trim();
  if (v instanceof Date) return v.toISOString();
  return JSON.stringify(v);
};

// A fingerprint covers EVERY field the importer writes, so two rows only match
// when they are identical in all of them (not just GİB no / ETTN).
export const rowFingerprint = (row, keys) =>
  JSON.stringify(keys.map((k) => normalizeValue(row[k])));

// Splits parsed rows into ones that should be written and ones that already
// exist in Firestore (or repeat inside the same file) as an exact match.
export const splitDuplicateRows = async (mappedRows) => {
  if (!mappedRows.length) return { newRows: [], existingDuplicates: 0, inFileDuplicates: 0 };

  const keys = Object.keys(mappedRows[0]).sort();
  // BütçeTipi is part of the fingerprint, so only same-type records can ever match.
  const types = [...new Set(mappedRows.map((r) => r.BütçeTipi).filter(Boolean))];
  const existing = new Set();
  for (const t of types) {
    const snap = await getDocs(query(collection(db, 'Budgets'), where('BütçeTipi', '==', t)));
    snap.forEach((d) => existing.add(rowFingerprint(d.data(), keys)));
  }

  const seen = new Set();
  const newRows = [];
  let existingDuplicates = 0;
  let inFileDuplicates = 0;
  for (const row of mappedRows) {
    const fp = rowFingerprint(row, keys);
    if (existing.has(fp)) { existingDuplicates += 1; continue; }
    if (seen.has(fp)) { inFileDuplicates += 1; continue; }
    seen.add(fp);
    newRows.push(row);
  }
  return { newRows, existingDuplicates, inFileDuplicates };
};
